import React, { useContext } from "react";
import "./DocumentDetail.css";
import DocumentDetailProvider from "./DocumentDetailProvider";
import DocumentDetailWrapper from "./DocumentDetailWrapper";
const DocumentDetail = () => {

    return <DocumentDetailProvider>
        <DocumentDetailWrapper />
    </DocumentDetailProvider>
}

export default DocumentDetail;
